import React from 'react';

interface CardSubHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export default function CardSubHeader({
  children,
  className = '',
}: CardSubHeaderProps) {
  return (
    <div className={` ${className}`}>
      <p className="text-neutral-200 text-sm font-semibold pb-6">
        {' '}
        {children}{' '}
      </p>
    </div>
  );
}
